import { CONTACT_PAGE_URL, SESSIONS_PAGE_URL, TRIBUTE_PAGE_URL } from '../Routes';

export const faqsArray = [
  {
    question: 'What types of sessions do you offer?',
    answer:
      'In-person domination, sensual sadism, mind-fuck experiences, and indoctrination & propaganda play. Impact, medicals, sissification and pegging to name a few! Enquire about your kinks. Each session is tailored to your obedience and devotion. Full details are on the <a href="' +
      SESSIONS_PAGE_URL +
      '" class="text-colour1 underline">Sessions</a> page.',
  },
  {
    question: 'Do you offer online sessions?',
    answer:
      'Yes. I conduct online hypnosis and select rituals virtually. These can include guided trance, indoctrination, obedience training, or ritual assignments. Distance does not free you from My control.',
  },
  {
    question: 'What should I expect from my first session?',
    answer:
      'Expect a clear discussion of limits and expectations, followed by immediate immersion in My control. Cleanliness, punctuality, and honesty are required. I decide how far you fall.',
  },
  {
    question: 'Do you require a deposit?',
    answer:
      'Yes. A deposit is always required to secure your time with Me. This ensures your sincerity and commitment.',
  },
  {
    question: 'What is your cancellation policy?',
    answer:
      `Non refundable deposit
       - If I must cancel: deposit refunded or transferred to a new date at My discretion.`,
  },
  {
    question: 'Is discretion guaranteed?',
    answer:
      'Absolutely. My dungeon is private and immaculate. Your identity and secrets remain sealed under My watchful eyes.',
  },
  {
    question: 'How can I contact you?',
    answer:
      `Use the <a href="${CONTACT_PAGE_URL}" class="text-colour1 underline">contact page</a> to reach Me with inquiries or booking requests. Be polite, concise, and prepared to screen.`,
  },
  {
    question: 'Do you offer sponsored travel or FMTY?',
    answer:
      'Yes. Fly Me To You is available with tribute and all travel expenses covered. Minimum booking lengths and deposits apply. Advance notice is required.',
  },
  {
    question: 'Are you touring? Will you come to my city?',
    answer:
      `Check the <a href="${SESSIONS_PAGE_URL}" class="text-colour1 underline">sessions & tour page</a> for My current travel schedule. Obedient devotees may also sponsor travel.`,
  },
];
